const ValidateRequired = (value) => {
    return value.trim().length > 0;
};

export default ValidateRequired